<template>
  <div>
    <div class="is-mobile columns">
      <div v-if="whatsapp" class="column">
        <a :href="whatsapp"
          ><b-button expanded class="has-text-dark card-header-title" type="is-success is-light"
            >JOIN WHATSAPP GROUP</b-button
          ></a
        >
      </div>
      <div v-if="payment" class=" column">
        <a :href="payment"
          ><b-button class="has-text-dark card-header-title" expanded type="is-link is-light">PAY ONLINE</b-button></a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed:{
    ...mapState({
      whatsapp: (state) => state.info.whatsapp,
      payment: (state) => state.info.payment
    })
  }
};
</script>
